export * from './productCharacteristicsTable';
